<template lang="pug">
  .wt-wysiwyg.editor__content
    Editor(
      api-key=""
      :init="options"
      initial-value=""
      :inline="false"
      tag-name="div"
      value=""
      v-model="localContent"
    )
</template>

<script>
import "tinymce";
// Default icons are required for TinyMCE 5.3 or above
import "tinymce/icons/default";
// A theme is also required
import "tinymce/themes/silver";

// Any plugins you want to use has to be imported
import "tinymce/plugins/paste";
import "tinymce/plugins/link";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "WtWysiwyg",

  components: { Editor },

  props: {
    content: {
      type: String,
      default: ""
    },

    selector: {
      type: String,
      default: ".wt-wysiwyg"
    },

    height: {
      type: Number,
      default: 500
    }
  },

  data() {
    const token = this.$auth.token();

    return {
      localContent: this.content,
      options: {
        selector: this.selector,
        relative_urls: false,
        remove_script_host: false,
        // for reference - we can do whatever here
        // setup: function (editor) {
        //   editor.on('blur', function (e) {
        //     __this.doSomething(e);
        //   })
        // },
        paste_data_images: false,
        images_upload_handler: (blobInfo, success, failure, progress) => {
          let xhr, formData;

          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", `${process.env.VUE_APP_API_URL_BASE}notices`);
          // manually set auth header
          xhr.setRequestHeader("Authorization", "Bearer " + token);

          xhr.upload.onprogress = function(e) {
            progress((e.loaded / e.total) * 100);
          };

          xhr.onload = function() {
            let json;

            if (xhr.status < 200 || xhr.status >= 300) {
              failure("HTTP Error: " + xhr.status);
              return;
            }

            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.data.storagePath != "string") {
              failure("Invalid JSON: " + xhr.responseText);
              return;
            }

            success(json.data.storagePath);
          };

          xhr.onerror = function() {
            failure(
              "Image upload failed due to a XHR Transport error. Code: " +
                xhr.status
            );
          };

          formData = new FormData();
          formData.append("image", blobInfo.blob(), blobInfo.filename());

          xhr.send(formData);
        },
        skin: false,
        content_css: "/.editor__content.css",
        branding: false,
        height: this.height,
        content_style:
          "body { font-size: 16px; font-weight: 500; line-height: 24px; }",
        menubar: false,
        plugins: ["lists", "link", "image", "wordcount", "paste"],
        toolbar_mode: "wrap", // https://www.tiny.cloud/docs/configure/editor-appearance/#toolbar_mode - floating menu doesn't hide
        toolbar: `undo redo | h1 bold italic underline | link image | bullist numlist | removeformat`,
        fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt",
        paste_remove_spans: true,
        paste_remove_styles: true,
        paste_auto_cleanup_on_paste: true
      }
    };
  },

  watch: {
    localContent(newLocalContent) {
      this.$emit("update:content", newLocalContent);
    },
    content(newContent) {
      this.localContent = newContent;
    }
  },

  methods: {
    applyTextEdit($event) {
      this.localContent = $event.api.origElements.innerHTML;
    }
  }
};
</script>

<style lang="sass" scoped>
#wt-wysiwyg
  @import "@~tinymce/skins/ui/oxide/skin.min.css"
.tox-tinymce
  border-radius: $radius-large
</style>
